<div class="bg-white">
     <HomeNavBar />

  <div class="container">

    <div class="p-3 rounded mb-1">
      <h2 class="section-title-census">Empower Yourself with Gender-Based Analysis</h2>
      <div class="underline"></div>
        <p class="text-muted mt-2">
        These online courses helps you understand how to apply gender, youth, and disability perspectives
        to policies, programs, and initiatives, ensuring inclusive and impactful outcomes.
      </p>
    </div>

    <div class="row g-4 align-items-start">
      <!-- Left card -->
      <div class="col-md-8">
        <div class="courses-card">
          <h2>
            GENDER-BASED ANALYSIS PLUS
          </h2>
          <a class="btn knowledgehub-btn shadow-sm rounded-3 align-self-start mt-2" href="https://learning.dwypd.gov.za/global_course/">Learn More <i class="bi bi-arrow-right"></i></a>
        </div>
      </div>

      <!-- Right content -->
      <div class="col-md-4 h-100">
        <p class="fw-500">GBA Plus online course seeks to support the development of
            responsive and inclusive initiatives, including policies, programs, and
            other initiatives :</p>
       <div class="d-flex">
            <i class="bi bi-1-circle-fill color-green"></i>
             <p class="mb-3 text-xs mx-2">
             An analytical tool for understanding who is impacted by the issue being
            addressed by the initiative from a gender, youth and disability perspective.
           </p>
        </div>

        <div class="d-flex ">
            <i class="bi bi-2-circle-fill color-green"></i>
             <p class="mb-3 text-xs mx-2">
             Identifying how the initiative could be tailored to impact positively on the
           </p>
        </div>

        <div class="d-flex">
            <i class="bi bi-3-circle-fill color-green"></i>
            <p class="mb-0 text-xs mx-2">
                Make gender equality central to the policies, programmes and
                interventions through gender mainstreaming
            </p>
            </div>



        <a href="/knowledgehub" class="btn text-decoration-none text-start fw-bold mt-2 text-xs color-green">
          <i class="bi bi-arrow-left me-2 "></i> Back to home
        </a>
      </div>
    </div>
  </div>
</div>